import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import CoAwards01 from "../../assets/img/AboutSliderImages/CoAwards01.jpg";
import Ayana_Renewable_Engg_team_Award from "../../assets/img/AboutSliderImages/Ayana_Renewable_Engg_team_Award.jpg";
import Ayana_Renewable_MA_Award from "../../assets/img/AboutSliderImages/Ayana_Renewable_MA_Award.jpg";
import Ayana_Renewable_Saravanan_Award from "../../assets/img/AboutSliderImages/Ayana_Renewable_Saravanan_Award.jpg";
import CoAwards07 from "../../assets/img/AboutSliderImages/CoAwards07.jpg";
// import Best_Employer_Brand_Award from "../../assets/img/AboutSliderImages/Best_Employer_Brand_Award.jpg";
import CoAwards08 from "../../assets/img/AboutSliderImages/CoAwards08.jpg";
import CoAwards10 from "../../assets/img/AboutSliderImages/CoAwards10.jpg";
import CoAwards11 from "../../assets/img/AboutSliderImages/coaward11.JPG";
import ArrowLeft from "../../assets/left-arrow1.svg";
import ArrowRight from "../../assets/right-arrow1.svg";

const responsive = {
  xldesktop: {
    breakpoint: { max: 2526, min: 1920 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1536, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1000, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 100, min: 0 },
    items: 1,
  },
};

const AboutCarosel = () => {
  return (
    <section className="">
      <div className="container">
        <Carousel
          autoPlay={true}
          infinite
          responsive={responsive}
          itemClass="p-2"
        >
          <img className="w-100" src={CoAwards01} alt="arrow" />
          <img className="w-100" src={Ayana_Renewable_MA_Award} alt="arrow" />
          <img
            className="w-100"
            src={Ayana_Renewable_Engg_team_Award}
            alt="card"
          />
          <img
            className="w-100"
            src={Ayana_Renewable_Saravanan_Award}
            alt="arrow"
          />
          {/* <img className="" src={CoAwards07} alt="arrow" /> */}
          {/* <img className="w-100" src={Best_Employer_Brand_Award} alt="arrow" /> */}
          <img className="w-100" src={CoAwards08} alt="arrow" />
          <img className="w-100" src={CoAwards10} alt="arrow" />
          <img className="w-100" src={CoAwards11} alt="arrow" />
        </Carousel>
      </div>
    </section>
  );
};

export default AboutCarosel;
